import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import BasicLayout from '../layouts/BasicLayout';
import { useNavigate } from 'react-router-dom';

const UnauthorizedView = () => {
  const navigate = useNavigate();

  useEffect(() => {
    return navigate('/sign-out');
  }, []);

  return (
    <BasicLayout>
      <h1>403 - You Shall Not Pass</h1>
      <Link to="/sign-out">Back to Login</Link>
    </BasicLayout>
  );
};

export default UnauthorizedView;
